import { disableScrolling, enableScrolling } from '../utils/helpers';

class Modal {
  constructor() {
    this.modalOpened = false;

    this.$modal = $('.modal');
    this.$modalOverlay = $('.modal-overlay');
    this.$openBtn = $('.btn--modal');
    this.$closeBtn = this.$modal.find('.modal__close-icon');
    this.$modalForm = this.$modal.find('.modal__form');
    this.$modalContent = this.$modal.find('.modal__content');
    this.$modalVideo = this.$modal.find('.modal__video');
    this.formSubmitClass = '.modal__form-submit';

    this.init();
  }

  init() {
    this.$closeBtn.on('click', (e) => {
      e.stopPropagation();
      this.hideModal();
    });

    this.$openBtn.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const $data = $(e.currentTarget).data();

      this.showModal();

      if ($data && $data.video) {
        this.handleVideo($data.video);
        this.clearModalContent();
        this.$modalVideo.show();
      }

      if ($data && $data.pdfFile) {
        this.handlePdf($data.pdfFile);
        this.clearModalContent();
        const $form = $('#forminator-module-5');
        const $clonedForm = $form.clone(true);
        $form.remove();
        $clonedForm.find('.forminator-response-message').hide();

        this.$modalForm.append($clonedForm);
        this.$modalForm.find('.heading-md').show();
        this.$modalForm.show();
      }

      if ($data && $data.content && $data.name && $data.occupation) {
        this.handleContent($data.content, $data.name, $data.occupation);
        this.clearModalContent();
        this.$modalContent.show();
        this.$modal.addClass('team-modal');
      }
    });

    this.$modalOverlay.on('click', () => {
      this.hideModal();
    });

    $(document).on('forminator:form:submit:success', () => {
      const pdfFile = this.$modal.data('pdf');
      if (pdfFile) {
        const link = document.createElement('a');
        link.href = pdfFile;
        link.download = pdfFile;
        link.dispatchEvent(new MouseEvent('click'));
      }

      $('.modal h3').eq(0).hide();
      $('.forminator-response-message').show();
    });
  }

  clearModalContent() {
    this.$modalContent.hide();
    this.$modalForm.hide();
    this.$modalVideo.hide();
    this.$modal.removeClass('team-modal');
  }

  handleContent(content, name, occupation) {
    if (content) {
      this.$modal.find('.modal__content-copy').html(content);
    }

    if (name) {
      this.$modal.find('.modal__content h2').html(name);
    }

    if (occupation) {
      this.$modal.find('.modal__content span').html(occupation);
    }
  }

  handlePdf(pdfFile) {
    if (pdfFile) {
      this.$modal.data('pdf', pdfFile);
    } else {
      this.$modal.data('pdf', '');
    }
  }

  handleVideo(video) {
    if (video) {
      this.$modal.addClass('modal-video');
      this.$modalVideo.find('video').attr('src', video);
    }
  }

  showModal() {
    this.modalOpened = true;
    this.$modal.addClass('modal-active');
    this.$modalOverlay.addClass('overlay-active');
    $('.header').addClass('header--opacity');
    // disableScrolling();
  }

  hideModal() {
    this.modalOpened = false;
    this.$modal.removeClass('modal-active modal-video');
    this.$modalOverlay.removeClass('overlay-active');
    this.$modal.data('pdf', '');
    $('.header').removeClass('header--opacity');
    // enableScrolling();
  }
}

export default Modal;
